import { render, staticRenderFns } from "./WelcomeNotary.vue?vue&type=template&id=5aedd5db&scoped=true&"
import script from "./WelcomeNotary.vue?vue&type=script&lang=ts&"
export * from "./WelcomeNotary.vue?vue&type=script&lang=ts&"
import style0 from "./WelcomeNotary.vue?vue&type=style&index=0&id=5aedd5db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aedd5db",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VSnackbar,VTextField})
